import { render, staticRenderFns } from "./order-view-purchases.vue?vue&type=template&id=6e7506e4&scoped=true&"
import script from "./order-view-purchases.vue?vue&type=script&lang=js&"
export * from "./order-view-purchases.vue?vue&type=script&lang=js&"
import style0 from "./order-view-purchases.vue?vue&type=style&index=0&id=6e7506e4&prod&lang=scss&scoped=true&"
import style1 from "./order-view-purchases.vue?vue&type=style&index=1&id=6e7506e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7506e4",
  null
  
)

export default component.exports